import React from 'react';
import InfoConvertedFull from './InfoConvertedFull';
import { MainWrapper } from './styles';
import Picture from './Picture';

function MainConvertedFull({ posting, openDetailPosting }) {
  const {
    urlPicture,
    postingLocation,
    pricesOperationTypes,
    title,
    realEstateType,
    publicationType,
    postingFull
  } = posting;
  const { address } = postingLocation[0] || { address: '', zone: '', city: '' };

  return (
    <MainWrapper>
      <div className='picture-layout'>
        <Picture urlPicture={urlPicture} openDetailPosting={openDetailPosting} />
      </div>
      <InfoConvertedFull
        propertyType={realEstateType}
        title={title}
        address={address}
        pricesOperationTypes={pricesOperationTypes}
        openDetailPosting={openDetailPosting}
        publicationType={publicationType}
        isRented={postingFull && postingFull.statusPostingFull === 'OFFLINE'}
      />
    </MainWrapper>
  );
}

export default MainConvertedFull;
